module.exports = __webpack_public_path__ + "img/header-engagementRingsBudgetLow.2da1a5e.jpg";